import { createApp } from 'vue'
import App from './App.vue'
import router from './router'

const app = createApp(App);

app.config.globalProperties.baseUrl='https://rev-proxy-foxbel.herokuapp.com'

app.use(router).mount('#app')
